<div class="content" fxLayout="column" fxLayout.sm="column" fxLayout.xs="column" fxLayoutGap="16px" [@routeAnimation]="true">
    <!-- Add screen content here -->
    <!-- <div class="cc-forms-container"> -->
    <div class="accDist-loading-shade" *ngIf="isLoading">
        <mat-spinner *ngIf="isLoading"></mat-spinner>
    </div>
    <div fxLayout="column">
        <mat-form-field>
            <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Filter">
        </mat-form-field>
    </div>
    <div fxLayout="column" class="mat-elevation-z8 table-container">
        <mat-table #table [dataSource]="dataSource" matSort>
            <ng-container matColumnDef="code">
                <mat-header-cell style="flex-grow: 1;" *matHeaderCellDef mat-sort-header> Code </mat-header-cell>
                <mat-cell style="flex-grow: 1;" *matCellDef="let row"> {{row.code}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="description">
                <mat-header-cell style="flex-grow: 3;" *matHeaderCellDef mat-sort-header> Description </mat-header-cell>
                <mat-cell style="flex-grow: 3;" *matCellDef="let row"> {{row.descr}} </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
        </mat-table>
    </div>
    <div fxLayout="column">
        <mat-paginator [pageSizeOptions]="[5, 10, 25, 100, 125, 150, 175, 200]"></mat-paginator>
    </div>
</div>